var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle, _path30, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 37,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.66 10.58H1.6v24.55h36.05V10.58Z",
    fill: "#E6A347"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.19 32.81V19.3h-9.26V32.8h9.26Z",
    fill: "#71C1DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 19,
    width: 11,
    height: 14
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.19 32.81V19.3h-9.26V32.8h9.26Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.24 32.81h4.03L20.76 19.3h-4.03l7.51 13.51ZM29.88 32.81h1.52L23.9 19.3h-1.53l7.51 13.51Z",
    fill: "#D6F0EF",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.92 21.4h-4.99V32.8h5V21.4ZM30.19 27.9h-1.8v4.91h1.8V27.9Z",
    fill: "#71C1DC",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.93 18.3v15.5H31.2V18.3H19.93Zm1 14.51v-6.76h9.26v-.65h-9.26v-6.1h9.26V32.8h-9.26Z",
    fill: "#80412F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 33.82h.3V18.31h-.3v15.51Z",
    fill: "#A46D47"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.63 32.81V19.3H9.38V32.8h9.25Z",
    fill: "#71C1DC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 19,
    width: 10,
    height: 14
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.64 32.81V19.3H9.38V32.8h9.26Z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.63 28.83H9.38v3.98h9.25v-3.98ZM14.37 25.53h-5v3.07h5v-3.07ZM14.37 22.24h-5v3.07h5v-3.07ZM18.62 26.33h-2.09v2.27h2.1v-2.27ZM18.62 23.85h-2.09v2.27h2.1v-2.27Z",
    fill: "#71C1DC",
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.69 32.81h4.03L9.2 19.3H5.18l7.5 13.51ZM18.33 32.81h1.52L12.34 19.3H10.8l7.52 13.51Z",
    fill: "#D6F0EF",
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38 18.3v15.5h11.26V18.3H8.38Zm1 14.51v-6.76h9.25v-.65H9.38v-6.1h9.25V32.8H9.38Z",
    fill: "#80412F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.08 33.82h.3V18.31h-.3v15.51Z",
    fill: "#A46D47"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.66 8.94H1.61v7.17a2.07 2.07 0 0 0 3.59-1.37c0 1.12.92 2.04 2.06 2.04 1.14 0 2.07-.91 2.07-2.04 0 1.12.92 2.04 2.06 2.04 1.14 0 2.06-.91 2.06-2.04 0 1.12.93 2.04 2.07 2.04 1.14 0 2.06-.91 2.06-2.04 0 1.12.93 2.04 2.07 2.04 1.14 0 2.06-.91 2.06-2.04 0 1.12.92 2.04 2.06 2.04 1.15 0 2.07-.91 2.07-2.04 0 1.12.92 2.04 2.06 2.04 1.14 0 2.07-.91 2.07-2.04 0 1.12.92 2.04 2.06 2.04 1.14 0 2.07-.91 2.07-2.04a2.07 2.07 0 0 0 3.57 1.4v-7.2Z",
    fill: "#C98439"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.13 14.5a2.05 2.05 0 0 1-2.07-2.04v-5.8H5.2v5.8c0 1.12-.92 2.04-2.06 2.04Z",
    fill: "#C9284E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 6.66h4.12v5.8c0 1.13-.93 2.04-2.06 2.04a2.05 2.05 0 0 1-2.07-2.04v-5.8Z",
    fill: "#E2E0E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.15 14.5a2.05 2.05 0 0 1-2.07-2.04v-5.8h4.13v5.8c0 1.12-.92 2.04-2.06 2.04ZM11.38 14.5a2.05 2.05 0 0 1-2.06-2.04v-5.8h4.13v5.8c0 1.12-.93 2.04-2.07 2.04Z",
    fill: "#C9284E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.45 6.66h4.12v5.8c0 1.13-.92 2.04-2.06 2.04a2.05 2.05 0 0 1-2.06-2.04v-5.8Z",
    fill: "#E2E0E3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.64 14.5a2.05 2.05 0 0 1-2.07-2.04v-5.8h4.13v5.8c0 1.12-.92 2.04-2.06 2.04Z",
    fill: "#C9284E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7 6.66h4.13v5.8c0 1.13-.93 2.04-2.07 2.04a2.05 2.05 0 0 1-2.06-2.04v-5.8Z",
    fill: "#E2E0E3"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9 14.5a2.05 2.05 0 0 1-2.07-2.04v-5.8h4.13v5.8c0 1.12-.93 2.04-2.07 2.04Z",
    fill: "#C9284E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.96 6.66h4.12v5.8c0 1.13-.92 2.04-2.06 2.04a2.05 2.05 0 0 1-2.06-2.04v-5.8Z",
    fill: "#E2E0E3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.27 33.93H0v1.2h39.27v-1.2Z",
    fill: "#CB1E48"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.27 33.82H0v.3h39.27v-.3Z",
    fill: "#DF3D55"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M33.14 2.4h-27v1.31h27V2.4Z",
    fill: "#CB1E48"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13 3.7h-3L1.06 6.67H5.2L9.13 3.7Z",
    fill: "#DF3D55"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M12.14 3.7h-3L5.18 6.67h4.13l2.82-2.95Z",
    fill: "#F3EFF1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 3.7h-3L9.33 6.67h4.13l1.68-2.95ZM33.14 3.7h-3l3.94 2.96h4.13L33.14 3.7Z",
    fill: "#DF3D55"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.14 3.7h-3l-1.7 2.96h4.13l.57-2.95Z",
    fill: "#F3EFF1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M21.14 3.7h-3l-.57 2.96h4.13l-.56-2.95Z",
    fill: "#DF3D55"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.14 3.7h-3l.56 2.96h4.13l-1.7-2.95Z",
    fill: "#F3EFF1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M27.14 3.7h-3l1.69 2.96h4.13L27.14 3.7Z",
    fill: "#DF3D55"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M30.14 3.7h-3l2.81 2.96h4.13L30.14 3.7Z",
    fill: "#F3EFF1"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.75,
    cx: 36.55,
    cy: 24.85,
    fill: "#fff",
    r: 6.87
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.58 19.15a5.73 5.73 0 1 0 0 11.46 5.73 5.73 0 0 0 0-11.46Zm-7.36 5.73a7.36 7.36 0 1 1 13.12 4.6l3 3a.82.82 0 0 1-1.15 1.16l-3.01-3a7.36 7.36 0 0 1-11.96-5.75Z",
    fill: "#08172B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 2.4)",
    d: "M0 0h39.27v32.73H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopIcon);
export default __webpack_public_path__ + "static/media/shopIcon.1180fc9e27b9589725b6b6da79ecd454.svg";
export { ForwardRef as ReactComponent };